import { NavAvatar as View } from 'header'
import { useIsAllToolsHidden } from '~map-preview/states/ui'

function AccountProfile() {
  const hidden = useIsAllToolsHidden()
  if (hidden) return null
  return <View />
}

export { AccountProfile }
